// Vendor Libs
import cloneDeep from 'lodash.clonedeep';

// Action Types
import {actionTypes} from '../action-types';

const initialState = {
  mode: 'view',
  storefrontData: {},
};

const actions = {
  [actionTypes.STOREFRONT_RESET]: () => cloneDeep(initialState),

  [actionTypes.STOREFRONT_SET_MODE]: (state, {mode}) => ({
    ...cloneDeep(state),
    mode,
  }),

  [actionTypes.STOREFRONT_SET_DATA]: (state, {storefrontData}) => ({
    ...cloneDeep(state),
    storefrontData,
  }),
};

export const storefrontReducer = (state = initialState, action) =>
  actions[action.type] ? actions[action.type](state, action.payload) : state;
